import React, { forwardRef } from 'react';
import styled from 'styled-components';

import aboutPic1 from '../assets/images/about1/1.jpg';
import aboutPic2 from '../assets/images/about1/2.jpg';
import aboutPic3 from '../assets/images/about1/3.jpeg';
import aboutPic4 from '../assets/images/about1/4.jpg';
import aboutPic21 from '../assets/images/about2/1.jpg';
import aboutPic22 from '../assets/images/about2/2.png';
import aboutPic23 from '../assets/images/about2/3.jpg';
import aboutPic24 from '../assets/images/about2/4.jpg';
import { useTheme } from '../contexts/ThemeProvider';
import { profile } from '../data/profile';

const About = forwardRef((props, ref) => {
	const color = useTheme();

	return (
		<AboutContainer color={color.color} ref={ref} id="about">
			<div className="header">
				<h1>About Me</h1>
				<h3>_who am i?</h3>
			</div>
			<div className="container">
				<div className="img-container">
					<div className="top-imgs">
						<img src={aboutPic1} alt="" />
						<img src={aboutPic2} alt="" />
					</div>
					<div className="bottom-imgs">
						<img src={aboutPic3} alt="" />
						<img src={aboutPic4} alt="" />
					</div>
				</div>

				<div className="details-container">
					<div className="detail-header">
						<h1>Hello</h1>
						<h2>
							<span>_meet, </span> {profile.handle}
						</h2>
					</div>

					<div className="detail-detail">
						<p>
							I’m <span>{profile.name},</span> a software engineer from Tondo, Manila, and the youngest of four
							siblings. I'm a {profile.role} at {profile.company}, where I lead the AI engineering team: I own the
							architecture of our multi-agent conversational AI pipeline, ship it to production on AWS, and mentor my
							teammates on LLM integration. I graduated Cum Laude with a Bachelor of Science in Information Technology
							from Universidad De Manila. I still build things for fun and learning, lately with LLMs in them.
						</p>
					</div>

					<div className="hobby-container">
						<h4>$coding</h4>
						<h4>$listening_to_music</h4>
						<h4>$basketball</h4>
						<h4>$singing</h4>
					</div>
				</div>
			</div>

			<div className="container">
				<div className="details-container">
					<div className="detail-header">
						<h1>dreams</h1>
						<h2>_things i want to achieve</h2>
					</div>

					<div className="detail-detail">
						<p>
							Ever since I was a child, I've dreamed of becoming a software engineer, and now I'm living the first
							chapter of that dream. My goal is to keep growing into the engineer the boy I used to be imagined, and to
							provide an abundant life for my family, my girlfriend, Sofia, and myself. It's a promise to give back to
							my parents by ensuring that they can enjoy a well-deserved retirement, and to my older brother, who gave
							me everything I needed in school without a second thought. Through perseverance and passion, I am
							dedicated to making these dreams come true.
						</p>
					</div>

					<div className="hobby-container">
						<h4>$ai_engineer</h4>
						<h4>$backend_dev</h4>
						<h4>$fullstack_dev</h4>
						<h4>$mobile_dev</h4>
					</div>
				</div>

				<div className="img-container">
					<div className="top-imgs">
						<img src={aboutPic21} alt="" />
						<img src={aboutPic22} alt="" />
					</div>
					<div className="bottom-imgs">
						<img src={aboutPic23} alt="" />
						<img src={aboutPic24} alt="" />
					</div>
				</div>
			</div>
		</AboutContainer>
	);
});

export default About;

const AboutContainer = styled.div`
	background-color: ${({ color }) => color.background};
	color: ${({ color }) => color.text};
	width: 100vw;
	padding: 0 8rem;
	padding-bottom: 7rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	gap: 1rem;

	.header {
		align-self: flex-start;
		padding-bottom: 2rem;
		h1 {
			color: ${({ color }) => color.text};
			text-transform: lowercase;
			font-size: 4rem;
			letter-spacing: 1px;
			font-weight: 800;
		}

		h3 {
			color: ${({ color }) => color.label};
			text-transform: lowercase;
			font-size: 1.5rem;
			letter-spacing: 1.5px;
		}
	}

	.container {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 5rem;
		padding: 2rem 0;
		border-radius: 12px;

		.img-container {
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 50%;
			height: 6rem;
			gap: 0.5rem;

			.top-imgs {
				width: 50%;
				display: flex;
				gap: 0.5rem;

				img {
					max-width: 100%;
					height: auto;
					border-radius: 3px;
					opacity: 0.2;
					transition: 0.2s ease-in-out, opacity 0.2s ease-in-out;
					transform: rotate(1deg);
					border: 2px solid transparent;
					&:hover,
					&:active {
						opacity: 1;
						border-radius: 15px;
						transform: translateY(-10px) translateX(10px); /* Elevates and tilts the image */
						box-shadow: 0 10px 30px ${({ color }) => color.imageShadow};
						border: 2px solid ${({ color }) => color.text};
					}
				}
			}
			.bottom-imgs {
				display: flex;
				gap: 0.5rem;
				width: 50%;
				perspective: 1000px;

				img {
					max-width: 100%;
					height: auto;
					border-radius: 3px;
					transition: 0.2s ease-in-out, opacity 0.2s ease-in-out;
					opacity: 0.2;
					transform: rotate(1deg);
					border: 2px solid transparent;

					&:hover,
					&:active {
						opacity: 1;
						border-radius: 15px;
						transform: translateY(-10px) translateX(-10px); /* Elevates and tilts the image */
						box-shadow: 0 10px 30px ${({ color }) => color.imageShadow};
						border: 2px solid ${({ color }) => color.text};
					}
				}
			}
		}

		.details-container {
			display: flex;
			flex-direction: column;
			justify-content: center;
			background-color: ${({ color }) => color.background};
			border: 2px solid ${({ color }) => color.text};
			width: 50%;
			height: auto;
			padding: 2rem 3rem;
			border-radius: 3px;
			gap: 1.5rem;
			h1 {
				text-transform: lowercase;
				font-size: 3rem;
			}
			h2 {
				color: ${({ color }) => color.label};
			}
			p {
				text-align: justify;
				/* text-transform: lowercase; */
				font-size: 1.4rem;
				line-height: 1.5;
				font-weight: 600;
				letter-spacing: 2px;
				color: ${({ color }) => color.label};
				span {
					color: ${({ color }) => color.text};
					font-weight: 800;
				}
			}

			.hobby-container {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				gap: 1rem;
				h4 {
					font-size: 1.3rem;
					letter-spacing: 1.6px;
					display: inline-block;
					border-radius: 3px;
					color: ${({ color }) => color.background};
					/* border: 0.5px solid ${({ color }) => color.primary}; */
					padding: 0.3rem 0.9rem;
					background-color: ${({ color }) => color.text};
					transition: 0.1s ease-in-out, opacity 0.1s ease-in-out;
				}
			}
		}
	}


	@media (max-width: 768px) {
		padding: 0 2rem;
		.header{
			h3{
			}
		}
		.container{
			flex-direction: column;
			padding: 2rem 0;
			gap: 2rem;

			.img-container{
				order: 1;
				width: 100%;
				height: auto;
			}

			.details-container{
				order:2;
				width: 100%;
				padding: 1rem 2rem;

			}
		}

	}

	@media (max-width: 1024px){
		.container{
			flex-direction: column;
			padding: 2rem 0;
			gap: 2rem;

			.img-container{
				order: 1;
				width: 100%;
				height: auto;
			}

			.details-container{
				order:2;
				width: 100%;
				padding: 1rem 2rem;

			}
		}
	}
`;
